import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import useScrollPosition from '../../../shared/hooks/useScrollPosition';
import logo from '../../../shared/assets/images/logo.png';
import './Navigation.css';

const Navigation = () => {
  const isScrolled = useScrollPosition(50);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSmoothScroll = (targetId) => {
    // If we're not on the homepage, navigate there first
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      // Use setTimeout to allow navigation to complete before scrolling
      setTimeout(() => {
        const element = document.getElementById(targetId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // We're already on homepage, just scroll
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    setIsMobileMenuOpen(false); // Close mobile menu after navigation
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`navigation ${isScrolled ? 'floating' : ''}`}>
        <div className="nav-container">
        <div className="nav-left">
          <Link to="/" className="nav-logo">
            <img src={logo} alt="Bounce Loyalty" className="nav-logo-img" />
          </Link>
          
          <div className="nav-menu">
            <button onClick={() => handleSmoothScroll('features')} className="nav-link">Features</button>
            <button onClick={() => handleSmoothScroll('how-it-works')} className="nav-link">How it Works</button>
            <Link to="/pricing" className="nav-link">Pricing</Link>
            <Link to="/about" className="nav-link">About Us</Link>
          </div>
        </div>
        
        <div className="nav-auth">
          <Link to="/businesssignin" className="nav-link signin">Sign In</Link>
          <Link to="/businesssignup" className="nav-button">Get Started</Link>
        </div>

        {/* Mobile menu button */}
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setIsMobileMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => handleSmoothScroll('features')} className="mobile-nav-link">Features</button>
            <button onClick={() => handleSmoothScroll('how-it-works')} className="mobile-nav-link">How it Works</button>
            <Link to="/pricing" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>Pricing</Link>
            <Link to="/about" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>About Us</Link>
            <Link to="/businesssignin" className="mobile-nav-link" onClick={() => setIsMobileMenuOpen(false)}>Sign In</Link>
            <Link to="/businesssignup" className="mobile-nav-link mobile-get-started" onClick={() => setIsMobileMenuOpen(false)}>Get Started</Link>
          </div>
        </div>
      )}
    </nav>
    </>
  );
};

export default Navigation;
